import SelectOptions from "../../select-options/SelectOptions.tsx";
import {useTranslation} from "react-i18next";
import {X} from "lucide-react";

const DesktopPricingCalculatorModal = (
    {setIsCalculatorModalOpen}: {setIsCalculatorModalOpen: (arg0: boolean) => void}
) => {

    const {t} = useTranslation();

    return (
        <>
            <div id="calculator-desktop" className="d-none d-md-block prices-example pt-6 pb-5">
                <button
                    className="position-absolute fs-3 cursor-pointer close-button"
                    style={{top: '10px', right:' 30px', background: 'none', border: 'none'}}
                    onClick={() => setIsCalculatorModalOpen(false)}
                >
                    <X />
                </button>
                <div className="fs-7 fw-semibold text-center text-blue-dark eld">
                    <h2 className="fs-3 fs-md-3 elh">{t('commission_calculator')}</h2>
                </div>
                <SelectOptions flex={true}
                               sectionClass={'calculator_el'}
                               sectionHeadingClass={undefined}
                               mobile={false} />
            </div>
        </>
    )
}

export default DesktopPricingCalculatorModal;
